import { Avatar, Badge, Box, ClickAwayListener, Divider, IconButton, Popper, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import EmojiPicker from 'emoji-picker-react'
import { Send } from '@mui/icons-material'
import { observer } from 'mobx-react'
import { toast } from 'react-toastify'

import { formatDate, Icons, latexDelimiters, POLL_OPTIONS_COLORS, USER_CARD_COLOR_SETS } from '../../../utils/utilities'
import { useSocketsContext } from '../../../contexts/sockets.context'
import { useMeetingStore } from '../../../store/meeting.store'
import Latex from 'react-latex-next'
import { useOnlineSessionsSocketStore } from '../../../store/onlinesessionsocket.store'

const Chats = observer( () => {

    const [showEmojiPicker, setShowEmojiPicker] = useState( false )
    const [message, setMessage] = useState( "" )

    const { palette, theme, border } = useTheme()
    const { meeting_id } = useParams()

    // const { socket, emitEvent } = useSocketsContext()

    const chatsEndRef = useRef()
    const messageBoxRef = useRef()
    const messageInputRef = useRef()

    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()
    const MeetingStore = useMeetingStore()

    const handleEmojiClick = ( emojiObject ) => {
        setMessage( ( prev ) => prev + emojiObject.emoji )
        if ( messageInputRef.current ) {
            messageInputRef.current.focus()
            const length = messageInputRef.current.value.length
            messageInputRef.current.setSelectionRange( length, length )
        }
    }

    const setCurrentChatRecipent = ( chatId, user = {} ) => {
        const newIndicatorsState = { ...MeetingStore.getMeetingChatsDetails.indicators }
        newIndicatorsState.tabs[chatId] = 0
        MeetingStore.setMeetingChatsDetails( {
            currentChatId: chatId,
            currentChatRecipent: { name: user?.name, user_id: user?.user_id, color_index: user?.color_index },
            indicators: newIndicatorsState
        } )
    }

    const sendNewMessage = async ( event ) => {
        let trimmedMessage = message?.trim()
        if ( !trimmedMessage )
            return event.target?.focus()
        const { currentChatId, recentChats } = MeetingStore.getMeetingChatsDetails

        if ( currentChatId === meeting_id ) {

            const { success, message: socketMessage } = await OnlineSessionSocketStore.emit(
                "chat:send-room-message",
                {
                    room_id: meeting_id,
                    message: trimmedMessage
                } )

            if ( success ) {
                setMessage( "" )
            }
            if ( socketMessage )
                toast( socketMessage )
        }
        else {
            const currentChatUserDetails = recentChats.find( u => u.chat_id === currentChatId )

            if ( !currentChatUserDetails ) return

            const { success, message: socketMessage } = await OnlineSessionSocketStore.emit(
                "chat:send-private-message",
                {
                    room_id: meeting_id,
                    chat_id: currentChatUserDetails.chat_id,
                    to_user_id: currentChatUserDetails.user_id,
                    message: trimmedMessage
                } )

            if ( success ) {
                setMessage( "" )
            }
            if ( socketMessage )
                toast( socketMessage )
        }
    }

    const handleKeyDownOnMessageInput = ( event ) => {
        const { code, shiftKey } = event

        if ( ( code === 'Enter' || code === 'NumpadEnter' ) && !shiftKey ) {
            event.preventDefault()
            sendNewMessage( event )
        }
    }

    useEffect( () => {
        chatsEndRef.current?.scrollIntoView( { behavior: "smooth" } )
    }, [MeetingStore.getChats, MeetingStore.getPollResults, MeetingStore.getMeetingChatsDetails?.currentChatId] )


    return (
        <Box borderTop={border[1]} flexGrow={1} overflow="auto" display="flex" flexDirection="column">
            <Box flexGrow={1} display="flex" overflow="auto" >
                <Box flexShrink={0} minWidth={0} className="slim-custom-scrollbar" overflow="auto" maxWidth="80px" display="flex" flexDirection="column" gap="2px" height="100%" borderRight={border[1]} >
                    <Box flexShrink={0} onClick={() => setCurrentChatRecipent( meeting_id )} overflow="visible" width="100%" sx={{ cursor: "pointer", borderRight: MeetingStore.getMeetingChatsDetails?.currentChatId === meeting_id ? `2px solid ${palette.primary.dark}` : `2px solid rgba(0,0,0,0)`, bgcolor: MeetingStore.getMeetingChatsDetails?.currentChatId === meeting_id && palette.primary.light + "22", width: "60px", boxSizing: "border-box", ":hover": { bgcolor: palette.primary.light + "22" } }} display="flex" flexDirection="column" alignItems="center" gap="2px" padding="5px 8px 5px 10px">
                        <Badge invisible={!Boolean( MeetingStore.getMeetingChatsDetails?.indicators?.tabs[meeting_id] )} badgeContent={MeetingStore.getMeetingChatsDetails?.indicators?.tabs[meeting_id] ?? 0} max={10} color='secondary' overlap='circular'  >
                            <Avatar sx={{ color: palette.common.white, width: "30px", height: "30px", background: USER_CARD_COLOR_SETS[2].primary }} >
                                {Icons.small.Groups2}
                            </Avatar>
                        </Badge>
                        <Typography width="100%" noWrap fontSize="10px" variant='subtitle2' textAlign="center">Public</Typography>
                    </Box>
                    <Box flexShrink={0} onClick={() => setCurrentChatRecipent( `${meeting_id}-polls` )} overflow="visible" width="100%" sx={{ cursor: "pointer", borderRight: MeetingStore.getMeetingChatsDetails?.currentChatId === `${meeting_id}-polls` ? `2px solid ${palette.primary.dark}` : `2px solid rgba(0,0,0,0)`, bgcolor: MeetingStore.getMeetingChatsDetails?.currentChatId === `${meeting_id}-polls` && palette.primary.light + "22", width: "60px", boxSizing: "border-box", ":hover": { bgcolor: palette.primary.light + "22" } }} display="flex" flexDirection="column" alignItems="center" gap="2px" padding="5px 8px 5px 10px">
                        <Badge invisible={!Boolean( MeetingStore.getMeetingChatsDetails?.indicators?.tabs[`${meeting_id}-polls`] )} badgeContent={MeetingStore.getMeetingChatsDetails?.indicators?.tabs[`${meeting_id}-polls`] ?? 0} max={10} color='secondary' overlap='circular'  >
                            <Avatar sx={{ color: palette.common.white, width: "30px", height: "30px", background: USER_CARD_COLOR_SETS[2].primary }} >
                                {Icons.small.Checklist}
                            </Avatar>
                        </Badge>
                        <Typography width="100%" noWrap fontSize="10px" variant='subtitle2' textAlign="center">Polls</Typography>
                    </Box>
                    {MeetingStore.getMeetingChatsDetails?.recentChats?.map( user => (
                        <Box flexShrink={0} onClick={() => setCurrentChatRecipent( user.chat_id, user )} key={user.chat_id} overflow="visible" width="100%" sx={{ cursor: "pointer", borderRight: MeetingStore.getMeetingChatsDetails?.currentChatId === user.chat_id ? `2px solid ${palette.primary.dark}` : `2px solid rgba(0,0,0,0)`, bgcolor: MeetingStore.getMeetingChatsDetails?.currentChatId === user.chat_id && palette.primary.light + "22", width: "60px", boxSizing: "border-box", ":hover": { bgcolor: palette.primary.light + "22" } }} display="flex" flexDirection="column" alignItems="center" gap="2px" padding="5px 8px 5px 10px">
                            <Badge invisible={!Boolean( MeetingStore.getMeetingChatsDetails?.indicators?.tabs[user.chat_id] )} badgeContent={MeetingStore.getMeetingChatsDetails?.indicators?.tabs[user.chat_id] ?? 0} max={10} color='secondary' overlap='circular'  >
                                <Avatar sx={{ width: "30px", height: "30px", fontSize: "14px", background: USER_CARD_COLOR_SETS[user.color_index || 4].primary, color: palette.common.white }} >{user.name?.[0]?.toUpperCase()}</Avatar>
                            </Badge>
                            <Tooltip title={user.name} disableInteractive placement='right' >
                                <Typography width="100%" noWrap sx={{ textOverflow: "clip" }} fontSize="10px" variant='subtitle2' textAlign="center">{user.name}</Typography>
                            </Tooltip>
                        </Box>
                    ) )}
                </Box>
                <Box flexGrow={1} height="100%" display="flex" overflow="hidden" flexDirection="column" >
                    {MeetingStore.getMeetingChatsDetails?.currentChatId === meeting_id ? <Box display="flex" width="100%" overflow="hidden" minHeight={0} flexShrink={0} gap="10px" alignItems="center" borderBottom={border[1]} padding="10px">
                        <Avatar sx={{ color: palette.common.white, width: "30px", height: "30px", background: USER_CARD_COLOR_SETS[2].primary }} >
                            {Icons.small.Groups2}
                        </Avatar>
                        <Box flexGrow={1} overflow="hidden">
                            <Typography fontWeight={500} minWidth={0} noWrap width="100%" display="block" fontSize="12px" component="p">{MeetingStore.getCurrentMeeting.meeting_type === 'webinar' ? "Webinar" : MeetingStore.getCurrentMeeting.meeting_type === 'class' ? "Class" : "Meeting"}</Typography>
                            <Typography fontWeight={300} display="block" fontSize="10px" component="em">Public conversations </Typography>
                        </Box>
                    </Box> : MeetingStore.getMeetingChatsDetails?.currentChatId === `${meeting_id}-polls` ? <Box display="flex" width="100%" overflow="hidden" minHeight={0} flexShrink={0} gap="10px" alignItems="center" borderBottom={border[1]} padding="10px">
                        <Avatar sx={{ color: palette.common.white, width: "30px", height: "30px", background: USER_CARD_COLOR_SETS[2].primary }} >
                            {Icons.small.Checklist}
                        </Avatar>
                        <Box flexGrow={1} overflow="hidden">
                            <Typography fontWeight={500} minWidth={0} noWrap width="100%" display="block" fontSize="12px" component="p">Poll results</Typography>
                            <Typography fontWeight={300} display="block" fontSize="10px" component="em">Published poll results</Typography>
                        </Box>
                    </Box> : <Box display="flex" width="100%" overflow="hidden" minHeight={0} flexShrink={0} gap="10px" alignItems="center" borderBottom={border[1]} padding="10px">
                        <Avatar sx={{ width: "30px", height: "30px", fontSize: "14px", background: USER_CARD_COLOR_SETS[MeetingStore.getMeetingChatsDetails?.currentChatRecipent?.color_index || 4].primary, color: palette.common.white }} >{MeetingStore.getMeetingChatsDetails?.currentChatRecipent?.name?.[0]?.toUpperCase()}</Avatar>
                        <Box flexGrow={1} overflow="hidden">
                            <Typography fontWeight={500} minWidth={0} noWrap width="100%" display="block" fontSize="12px" component="p">{MeetingStore.getMeetingChatsDetails?.currentChatRecipent?.name}</Typography>
                            <Typography fontWeight={300} display="block" fontSize="10px" component="em">Private Conversation</Typography>
                        </Box>
                    </Box>}
                    <Box minHeight={0} overflow="auto" className="slim-custom-scrollbar" padding="10px" flexGrow={1}>
                        <Box display="flex" flexDirection="column" gap="10px" overflow="auto">
                            {MeetingStore.getMeetingChatsDetails?.currentChatId !== `${meeting_id}-polls` && MeetingStore.getChats[MeetingStore.getMeetingChatsDetails.currentChatId]?.map( ( chat, index ) => (
                                <Box display="flex" justifyContent={MeetingStore.getLocalUser?.user_id === chat.user_id ? "flex-end" : "flex-start"} key={chat.id || chat.timestamp} >
                                    <Box borderRadius="5px" overflow="hidden" maxWidth="75%" display="flex" flexDirection="column" alignItems={MeetingStore.getLocalUser?.user_id === chat.user_id ? "flex-end" : "flex-start"} padding="5px 10px" border={border[1]} >
                                        {chat.type === "room" && MeetingStore.getLocalUser?.user_id !== chat.user_id && <Typography width="100%" noWrap fontSize="12px" fontWeight="600" textTransform="capitalize" ><em>{chat.name?.toLowerCase()}</em></Typography>}
                                        <Typography width="100%" fontSize="12px">
                                            {chat.message}
                                            <Typography component="span" marginTop="0px" width="100%" textAlign="right" display="block" color='GrayText' fontSize="10px">{formatDate( chat.timestamp || chat.created_at, { format: "hh:mm A" } )}</Typography>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) )}


                            {/* POLLS */}
                            {MeetingStore.getMeetingChatsDetails?.currentChatId === `${meeting_id}-polls` && MeetingStore.getPollResults?.map( ( poll, index ) => (
                                (
                                    <Box key={poll.id || poll.created_at} >
                                        <Box borderRadius="5px">
                                            <Typography gutterBottom fontSize="14px" whiteSpace="break-spaces" sx={{ wordBreak: "break-all", overflow: "hidden", display: "inline-block", wordWrap: "break-word" }} component="div" fontWeight={500}> <Latex delimiters={latexDelimiters}>{poll.question}</Latex> </Typography>
                                            {poll.options?.map( ( option, i ) => (
                                                <Box marginBottom='5px' border={border[1]} display="flex" borderRadius="5px" overflow="clip" bgcolor={palette.form.inputBg} alignItems="stretch" key={i}>
                                                    <Box position="relative" padding="2px 5px" width="100%">
                                                        <Typography position="relative" component="div" fontSize="10px" zIndex={2} display="block">
                                                            <Latex delimiters={latexDelimiters}>{option}</Latex>
                                                        </Typography>
                                                        <Typography position="relative" zIndex={2} display="block" fontSize="8px">{poll?.totalVotes > 0 ? `${Math.round( ( ( poll.votes?.[i]?.length || 0 ) * 100 ) / poll?.totalVotes )}%` : "0%"}</Typography>
                                                        {/* VOTES INDICATOR */}
                                                        <Box position="absolute" zIndex={1} sx={{ background: `${POLL_OPTIONS_COLORS[i]}` }} borderRadius="0 20px 20px 0" left="0" bottom="0" top="0" width={`${( ( poll.votes?.[i]?.length || 0 ) * 100 ) / poll?.totalVotes}%`} height="100%" ></Box>
                                                    </Box>
                                                </Box>
                                            ) )}
                                            <Typography textAlign="right" gutterBottom fontSize="8px" fontWeight={500}>{formatDate( poll.created_at || poll.timestamp, { format: "hh:mm A" } )}</Typography>
                                        </Box>
                                        <Divider sx={{ mt: "10px" }} />
                                    </Box>
                                )
                            ) )}

                            <Box ref={chatsEndRef} />
                        </Box>
                        {MeetingStore.getMeetingChatsDetails?.currentChatId !== `${meeting_id}-polls` && MeetingStore.getChats[MeetingStore.getMeetingChatsDetails.currentChatId]?.length === 0 && <Box height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            <Typography textAlign="center" variant='subtitle2' >No Messages</Typography>
                        </Box>}
                        {MeetingStore.getMeetingChatsDetails?.currentChatId === `${meeting_id}-polls` && MeetingStore.getPollResults?.length === 0 && <Box width="100%" flexGrow={1} height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            <Typography textAlign="center" variant='subtitle2' >There are no polls!</Typography>
                        </Box>}
                    </Box>
                    {!MeetingStore.getCurrentMeetingSettings.enable_chats && <Typography margin="10px" gutterBottom pading="10px" borderRadius="10px" bgcolor={palette.error.light + "55"} color={palette.error.dark} textAlign="center" variant='subtitle2' border={`1px solid ${palette.error.dark}`} >
                        Messages has been disabled
                    </Typography>}

                </Box>
            </Box>
            {MeetingStore.getMeetingChatsDetails?.currentChatId !== `${meeting_id}-polls` && <Box ref={messageBoxRef} flexShrink={0} borderTop={border[1]} padding="5px" display="flex" gap="5px" alignItems="flex-end" position="relative" >
                {/* Emoji Picker */}
                <Popper
                    placement="top"
                    sx={{ zIndex: 1700 }}
                    anchorEl={messageBoxRef.current}
                    open={showEmojiPicker}
                >
                    <ClickAwayListener onClickAway={() => setShowEmojiPicker( false )}>
                        <Box>
                            <EmojiPicker
                                theme={theme === 'system' ? "auto" : theme}
                                reactionsDefaultOpen
                                height={300}
                                emojiStyle="google"
                                lazyLoadEmojis
                                previewConfig={{ showPreview: false }}
                                onEmojiClick={handleEmojiClick}
                            />
                        </Box>
                    </ClickAwayListener>
                </Popper>

                {/* Emoji Button */}
                <IconButton
                    onClick={() => setShowEmojiPicker( ( prev ) => !prev )}
                    size="small"
                    sx={{ marginBottom: "5px" }}
                >
                    {Icons.default.EmojiEmotions}
                </IconButton>

                {/* Message Input */}
                <TextField
                    disabled={!MeetingStore.getCurrentMeetingSettings.enable_chats}
                    autoFocus
                    autoComplete='off'
                    aria-autocomplete='none'
                    value={message}
                    onKeyDown={handleKeyDownOnMessageInput}
                    onChange={( e ) => setMessage( e.target.value )}
                    placeholder="Type your message here..."
                    fullWidth
                    variant="standard"
                    sx={{ padding: "5px 10px", maxHeight: "100px", lineHeight: 1.5, overflow: "auto" }}
                    inputRef={messageInputRef}
                    slotProps={{
                        htmlInput: { sx: { fontSize: "12px" } },
                        input: { disableUnderline: true, sx: { background: "none" }, },
                    }}
                />

                {/* Send Button */}
                <IconButton onClick={sendNewMessage} sx={{ marginBottom: "5px" }} size="small">
                    <Send />
                </IconButton>
            </Box>}

        </Box>
    )
} )

export default Chats
